import 'component/css/search-list.css';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';

export const ListItem = ({title, desc, onSelect}) => {
  return (
    <div className="x-list-item" onMouseDown={onSelect}>
      <strong className="title">{ title }</strong>
      <span className="desc">{ desc }</span>
    </div>
  );
}

const SearchableList = (props) => {

  if ('function' !== typeof props.filter) throw new Error(`filter function must be specified in ${SearchableList.name}`);
  if (!props.withDefault) {
    if (null === props.value || 'undefined' === typeof props.value) {
      throw new Error(`null value is not supported without withDefault specified in ${SearchableList.name}`);
    }
  }

  const [ editMode, setEditMode ] = useState(false);
  const [ displayText, setDisplayText ] = useState(props.all?'全部':' - 請選擇 - ');
  const [ filteredItems, setFilteredItems ] = useState(props.items||[]);

  const [ dx_listStyle, setListStyle ] = useState({
    position: 'fixed',
    top: 0, left: 0,
    zIndex: 99999
  });


  const formatValue = props.format || (v => {
    let title = String(props.getTitle?.(v)||'').trim();
    let desc = String(props.getDesc?.(v)||'').trim();
    return `${title} - ${desc}`;
  });

  const ref_container = React.createRef();
  const ref_textbox   = React.createRef();
  const ref_list      = React.createRef();

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    if (editMode) ref_textbox.current?.focus();
  }, [editMode]);

  useEffect(() => {
    setFilteredItems(props.items);
  }, [props.items]);

  const setValue = (v) => {
    if (null === v || 'undefined' === typeof v) {
      if (!props.withDefault) throw new Error(`null value is not supported without withDefault specified in ${SearchableList.name}`);
      else v = props.withDefault;
    }

    if ('' === v) setDisplayText(props.all? '全部':' - 請選擇 - ');
    else {
      setDisplayText(formatValue(v));
    }
    props.onChange?.(v);
  }

  let __tid;
  const updateSearch = (e) => {
    // debounce
    if (__tid) window.clearTimeout(__tid);
    __tid = setTimeout(() => {
      __tid = null;
      let v = e.target.value.trim();
      if (v) setFilteredItems(props.items.filter(x => props.filter(x, v)));
      else setFilteredItems(props.items);
    }, 300);
  }

  const startEditMode = () => {
    updatePosition();
    setFilteredItems(props.items);
    // requires a delay to make sure this is
    // called at the end, and get successful focus
    setTimeout(()=>setEditMode(true), 0);
  }

  const updatePosition = () => {
    const C_PAD = 30;
    let rect = ref_container.current?.getBoundingClientRect();
    if (!rect) return;

    // default
    let minWidth  = rect.width;
    let maxWidth  = 'auto';
    let maxHeight = window.innerHeight - rect.height - rect.y - C_PAD;
    let top  = rect.bottom;
    let left = rect.left;

    // move left or right when height too small
    if (maxHeight < 100) {
      top = C_PAD;
      maxHeight = window.innerHeight - 2*C_PAD;

      let rectLs = ref_list.current?.getBoundingClientRect();

      if (!rectLs || window.innerWidth - rect.right > rect.left)
      { // right larger
        left = rect.right;
        maxWidth = window.innerWidth - rect.right - C_PAD;
      } else {
        // left larger
        left = rect.left - rectLs.width;
        maxWidth = rect.left - C_PAD;
      }
    }

    setListStyle({
      ...dx_listStyle
      ,minWidth, maxWidth, maxHeight
      ,top ,left
    });
  }

  //-----------------------------------------------
  // init
  useEffect(() => {
    window.addEventListener('scroll', updatePosition);
    window.addEventListener('resize', updatePosition);
    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    }
  });

  return (
  <div ref={ref_container} className="x-search-list">
    <div className={`x-control ${editMode?'focus':''}`}>
      { editMode
        ?<input ref={ref_textbox} className="x-search-box" placeholder="搜尋"
          onChange={updateSearch} onBlur={e=>setEditMode(false)} />
        :<div className="x-selected-value" onClick={startEditMode}>
          <span>{ displayText }</span>
          <FontAwesomeIcon icon={faCaretDown} className="dropdown-icon" />
        </div>
      }
    </div>
    { editMode &&
      <div className="x-dropdown" style={dx_listStyle} ref={ref_list}>
        { !!props.all && (props.component
          ?<props.component all={true} onSelect={e=>setValue('')} />
          :<ListItem onSelect={e=>setValue('')} title="All" desc="全部" />
        )}
        { !!props.withDefault && (props.component
          ?<props.component default={true} onSelect={e=>setValue(props.withDefault)} />
          :<ListItem onSelect={e=>setValue(props.withDefault)} title="NA" desc="無" />
        )}
        { filteredItems?.map((x, i) => props.component
          ?<props.component key={i} item={x} index={i} onSelect={e=>setValue(x)} />
          :<ListItem key={i} onSelect={e=>setValue(x)}
              title={props.getTitle?.(x)} desc={props.getDesc?.(x) ?? String(x)}
            />
        )}
      </div>
    }
  </div>);

}

export default SearchableList;
